import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import axios from "axios";
import { Fetch } from "../services/dataservice";
import { connect } from 'react-redux';

function UpdateProfile({ history, custInfo }) {
    const cId = parseInt(custInfo.map((item) => item.custId));    
    const [allStates, setAllStates] = useState([]);
    const [customerData, setCustomerData] = useState([]);        

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_BACKEND_BASE_URL}/States/GetState`)
            .then((response) => {
                setAllStates(response.data);
            });
        
        if (cId > 0) {
            // execute after 0.1 seconds for binding allStates before it
            const timer = setTimeout(() => {
                axios
                    .get(`${process.env.REACT_APP_BACKEND_BASE_URL}/Customer/GetById/` + cId)
                    .then((response) => {
                        setCustomerData(response.data);
                    });
            }, 100);
            return () => clearTimeout(timer);
        }  
    }, []);

    const statesfillData = [
        "All",
        ...new Set(allStates.map((data) => data.stateName)),
    ].map((d, index) => ({ id: index, stateName: d }));

    const statefields = { text: 'stateName', value: 'stateCode' };

    const handleStateChange = (e, property) => {
        //setCustomerData({ ...customerData, [property]: e.target.itemData.stateCode });
        setCustomerData({ ...customerData, [property]: e.target.value });
    };

    const handleChange = (e, property) => {
        setCustomerData({ ...customerData, [property]: e.target.value });
    };

    const handleUpdateProfile = async () => {
        try {            
            let result = await Fetch(`/Customer/Update`, "put", customerData);                
            if (result > 0) {
                alert("Updated successfully.");
            }            
        }
        catch (ex) {
            alert("Error...");
        }
    };

    return (
        <div className="int-container">
            <div class="container">
                <div class="form-container-large" style={{ width: "100%" }}>
                    <div class="form-group">
                        <h3 style={{ color: "#f19f1f", width: "100%", textAlign: "center" }}>Update Profile</h3>
                    </div>
                    <div class="col-md-4 form-group">
                        <label>First Name</label>
                        <TextBoxComponent cssClass="e-outline" value={customerData.firstName} onChange={(e) => handleChange(e, "firstName")} />
                    </div>
                    <div class="col-md-4 form-group">
                        <label>Last Name</label>
                        <TextBoxComponent cssClass="e-outline" value={customerData.lastName} onChange={(e) => handleChange(e, "lastName")} />
                    </div>
                    <div class="col-md-4 form-group">
                        <label>Phone</label>
                        <TextBoxComponent cssClass="e-outline" value={customerData.phone} onChange={(e) => handleChange(e, "phone")} />
                    </div>
                    <div class="col-md-4 form-group">
                        <label>Email</label>
                        <TextBoxComponent cssClass="e-outline" value={customerData.email} readOnly="true" />
                    </div>
                    <div class="col-md-4 form-group">
                        <label>Address Line 1</label>
                        <TextBoxComponent cssClass="e-outline" value={customerData.address} onChange={(e) => handleChange(e, "address")} />
                    </div>
                    <div class="col-md-4 form-group">
                        <label>Address Line 2</label>
                        <TextBoxComponent cssClass="e-outline" value={customerData.address1} onChange={(e) => handleChange(e, "address1")} />
                    </div>
                    <div class="col-md-4 form-group">
                        <label>City</label>
                        <TextBoxComponent cssClass="e-outline" value={customerData.city} onChange={(e) => handleChange(e, "city")} />
                    </div>
                    <div class="col-md-4 form-group">
                        <label>State</label>
                        <DropDownListComponent
                            id="ddlState"
                            cssClass="e-outline"
                            dataSource={allStates}
                            fields={statefields}
                            value={customerData.state}
                            onChange={(e) => handleStateChange(e, "state")}
                            placeholder="---Select---"
                            popupHeight="250px"
                        />
                        {/* <select class="form-control" value={customerData.state} onChange={(e) => handleStateChange(e, "state")}>
                            <option disabled selected>---Select---</option>
                            {
                                allStates.map(item=>{
                                    return(
                                        <option key={item.stateCode} value={item.stateCode}>{item.stateName}</option>
                                )}) 
                            }
                        </select> */}
                    </div>
                    <div class="col-md-4 form-group">
                        <label>Zip</label>
                        <TextBoxComponent cssClass="e-outline" value={customerData.zip} onChange={(e) => handleChange(e, "zip")} />
                    </div>
                    <div class="col-md-12 form-group" style={{ marginTop: "30px" }}>
                        <button className="btn btn-block btn-primary" onClick={handleUpdateProfile}>Update Profile</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = ({ login: { custInfo } }) => ({
    custInfo
})

export default connect(mapStateToProps)(withRouter(UpdateProfile));